import styled, { keyframes } from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Button, { BUTTON_VARIANTS } from '@common/components/Button';
import Modal from '@common/components/Modal';
import { ContentWrapper } from '@common/components/Modal/Modal.styled';
import { AspectRatioWrapper } from '@common/components/LazyImg/LazyImg.styled';

const fadein = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const ModalStyled = styled(Modal)`
  ${ContentWrapper} {
    margin: 0;
    padding-right: 0;
    padding-left: 0;
  }
`;

export const SwipeHandlerStyled = styled.div`
  width: 100%;
  height: 100%;
`;

export const ZoomModalBody = styled.div`
  .react-transform-component {
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100vh;
  background: rgb(240 241 242 / 100%);
  cursor: ${({ isGrabbing }) => (isGrabbing ? 'grabbing' : 'grab')};

  .zoom-wrapper {
    width: 100%;
    height: 100%;
  }

  ${AspectRatioWrapper} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    picture {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    img {
      opacity: 0;
      width: 100%;
      max-width: 3000px;
      height: 100%;
      max-height: 3000px;
      animation-name: ${fadein};
      animation-duration: 300ms;
      animation-delay: 100ms;
      animation-fill-mode: forwards;
      object-fit: contain;
    }
  }
`;

export const ZoomModalNavButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.LEVEL_2_BLUEGREY_90_SMALL,
})`
  position: fixed;
  right: ${({ direction }) => direction === 'right' && '2.5rem'};
  bottom: 1.5rem;
  left: ${({ direction }) => direction === 'left' && '2.5rem'};
  display: grid;
  place-items: center;
  width: 3.2rem;
  height: 3.2rem;
  box-shadow: ${({ theme }) => theme.shadows[4]};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadiuses.circle};
  padding: 0 0.3rem 0 0;
  background-color: ${getThemeColor('grey.100')};
  transform: ${({ isFlipped }) => isFlipped && 'rotate(180deg)'};

  &:focus {
    border: none;
    background-color: ${getThemeColor('grey.100')};
  }

  &:hover {
    box-shadow: ${({ theme }) => `${theme.shadows[6]}, ${theme.shadows[5]}`};
    border: none;
    background-color: ${getThemeColor('grey.100')};
  }
`;

export const ZoomModalPill = styled.div`
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  display: grid;
  place-items: center;
  height: 3rem;
  border-radius: 16px;
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'equal', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'equal', 5)}
  background-color: ${getThemeColor('bluegrey.95')};
  transform: translateX(-50%);
  pointer-events: none;
`;
